const React = require('react');
const { Link } = require('react-router-dom');
const { default: Button } = require('@mui/material/Button');
const { default: ArrowBack } = require('@mui/icons-material/ArrowBack');
const T = require('prop-types');
const BottomButtonContainer = require('components/BottomButtonContainer');
const UserPreferences = require('components/UserPreferences');
const ParticipationPreference = require('components/Gamification/ParticipationPreference');
const NerpyPreferences = require('components/Nerpy/Preferences');
const { default: Typography } = require('@mui/material/Typography');

const { default: Classes } = require('./styles.scss');

const internals = {};

internals.BASE_HEADERS = [
    'communications',
    'connections',
    'groups',
    'emails',
    'other'
];

internals.BASE_FIELDS = [
    'profileEmail',
    'connectionsVisibility',
    'groupVisibility',
    'groupMsgNotifications',
    'digestInterval',
    'pendingConnections',
    'careerAlerts',
    'messageNotifications'
];

internals.withOffers = (list, value, afterField) => {

    if (list.includes(value)) {
        return list;
    }

    const index = list.indexOf(afterField);
    const next = [...list];
    next.splice(index === -1 ? next.length : index + 1, 0, value);

    return next;
};

module.exports = class UserPreferencesPage extends React.PureComponent {

    static propTypes = {
        onSubmit: T.func.isRequired,
        onSubmitNoRedirect: T.func,
        onInvalidSubmit: T.func,
        preferences: T.object,
        hideJobAlerts: T.bool,
        showOffers: T.bool
    }

    constructor(props) {

        super(props);

        this.onUpdateButtonPress = this._onUpdateButtonPress.bind(this);
        this.setRef = this._setRef.bind(this);
        this.onChildFormSubmit = this._onChildFormSubmit.bind(this);
        this.onChildFormSubmitNoRedirect = this._onChildFormSubmitNoRedirect.bind(this);
        this.stillExists = true;
        this.state = { submitting: false };
    }

    componentDidMount() {

        window.scrollTo(0, 0);
    }

    componentWillUnmount() {

        this.stillExists = false;
    }

    _onUpdateButtonPress() {

        this.userPreferences.submit();
    }

    _onChildFormSubmit(preferences) {

        this.setState({ submitting: true });

        return this.props.onSubmit(preferences).then(() => {

            if (this.stillExists) {
                this.setState({ submitting: false });
            }
        }).catch((err) => {

            if (this.stillExists) {
                this.setState({ submitting: false });
            }

            throw new Error(err.message, {
                cause: err.cause
            });
        });
    }
    _onChildFormSubmitNoRedirect(preferences) {

        this.setState({ submitting: true });
        this.props.onSubmitNoRedirect(preferences).then(() => {

            if (this.stillExists) {
                this.setState({ submitting: false });
            }
        }).catch((err) => {

            if (this.stillExists) {
                this.setState({ submitting: false });
            }

            throw new Error(err.message,{
                cause:err.cause
            });
        });
    }

    _setRef(varName) {

        return (ref) => {

            this[varName] = ref;
        };
    }

    render() {

        const { showOffers } = this.props;

        const headersToShow = showOffers
            ? internals.withOffers(internals.BASE_HEADERS, 'offers', 'emails')
            : internals.BASE_HEADERS;

        const fieldsToShow = showOffers
            ? internals.withOffers(internals.BASE_FIELDS, 'offerAlerts', 'careerAlerts')
            : internals.BASE_FIELDS;

        return (
            <BottomButtonContainer
                btnLabel='Save'
                onBtnClick={this.onUpdateButtonPress}
                disabled={this.state.submitting}
            >
                <div className={Classes.wrapper}>
                    <div className={Classes.innerWrapper}>
                        <Button component={Link} to={this.props.location?.state?.fromNerpy ? '/app/nerpy' : '/app/welcome'} startIcon={<ArrowBack />} aria-label={this.props.location?.state?.fromNerpy ? `Back to ${this.props.location.state.assistantName || 'Nerpy'}` : 'Back to Home'}>Back</Button>
                        <Typography
                            variant='h2'
                            style={{
                                marginTop: 14,
                                marginBottom: 10
                            }}
                        >
                            User Preferences
                        </Typography>
                        <UserPreferences
                            ref={this.setRef('userPreferences')}
                            onSubmit={this.onChildFormSubmit}
                            onSubmitNoRedirect={this.onChildFormSubmitNoRedirect}
                            onInvalidSubmit={this.props.onInvalidSubmit}
                            preferencesSubmiting={this.state.submitting}
                            history={history}
                            hideJobAlerts={this.props.hideJobAlerts}
                            {...this.props}
                            headersToShow={headersToShow}
                            fieldsToShow={fieldsToShow}
                            beforeOther={() => <><ParticipationPreference /><NerpyPreferences /></>}
                        />
                    </div>
                </div>
            </BottomButtonContainer>
        );
    }
};
